import { DateType } from '../types';

export const formatDate = (date: DateType) => {
  if (!date) return '';
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  const yy = date.getFullYear();
  return `${yy}-${mm}-${dd}`;
};
